import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { Input, Button, ErrorSummary } from 'govuk-react-jsx';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  setBusinessVatRegistration,
  getBusinessVatRegistration,
  setBusinessVatData,
} from '../../features/pmc/pmcJourneySlice';
import { checkValidBusinessVAT } from '../../regex/regex';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import { checkVATNumber } from '../../firebase';
import useTitle from '../../hooks/useTitle';

const BusinessVatRegistration = () => {
  const businessVatRegistrationRedux = useSelector(getBusinessVatRegistration);
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;

  useTitle(
    'landlordReg.CompanyVATNumber.s10',
    'Enter VAT registration number - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );

  const dispatch = useDispatch();

  const history = useHistory();
  const [errorMsg, setErrorMsg] = useState('');
  const [errorList, setErrorList] = useState([]);

  const handleBusinessVatRegistration = (event) => {
    dispatch(setBusinessVatRegistration(event.target.value));
  };

  const errorMsgValid = copyProvider.getCopy(
    'landlordReg.CompanyVATNumber.s1',
    'Enter a valid VAT Registration number that consists of 9 characters and can contain letters and numbers'
  );
  const errorMsgNotValid = copyProvider.getCopy(
    'landlordReg.CompanyVATNumber.s2',
    'There is no company that matches the UK VAT registration number you have provided'
  );
  const errorMsgAlreadyExists = copyProvider.getCopy(
    'landlordReg.CompanyVATNumber.s9',
    'This number is already in use with another account'
  );

  const showError = {
    children: errorMsgValid,
  };

  const showErrorNotValidAPI = {
    children: errorMsgNotValid,
  };

  const showErrorAlreadyExistsAPI = {
    children: errorMsgAlreadyExists,
  };

  const handleBtnClick = () => {
    if (checkValidBusinessVAT.test(businessVatRegistrationRedux)) {
      setErrorMsg(null);

      checkVATNumber({ vatRegNumber: businessVatRegistrationRedux })
        .then((response) => {
          const { data } = response;

          dispatch(setBusinessVatData(data));

          if (
            data !== null &&
            data.vatRegNumber === businessVatRegistrationRedux
          ) {
            history.push('/pmcReg/confirm-business-VAT');
          } else {
            setErrorMsg(showErrorNotValidAPI);
            setErrorList([
              { ...showErrorNotValidAPI, href: '#companyRegistrationNumber' },
            ]);
          }
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.log('check VAT number error:', error);
          if (error.code === 'functions/already-exists') {
            setErrorMsg(showErrorAlreadyExistsAPI);
            setErrorList([
              {
                ...showErrorAlreadyExistsAPI,
                href: '#companyRegistrationNumber',
              },
            ]);
          } else {
            setErrorMsg(showErrorNotValidAPI);
            setErrorList([
              { ...showErrorNotValidAPI, href: '#companyRegistrationNumber' },
            ]);
          }
        });
    } else if (!checkValidBusinessVAT.test(businessVatRegistrationRedux)) {
      setErrorMsg(showError);
      setErrorList([{ ...showError, href: '#companyRegistrationNumber' }]);
    }
  };

  const pageModel = (
    <>
      {errorList?.length > 0 && (
        <ErrorSummary
          errorList={errorList}
          titleChildren={copyProvider.getCopy(
            'Common.error-summery',
            'There is a problem'
          )}
        />
      )}
      <div className="govuk-form-group">
        <h1 className="govuk-heading-xl">
          {copyProvider.getCopy(
            'landlordReg.CompanyVATNumber.s3',
            'Enter your VAT registration number'
          )}
        </h1>
        <p className="govuk-body">
          {copyProvider.getCopy(
            'landlordReg.CompanyVATNumber.s4',
            'We will use this to confirm your VAT details.'
          )}
        </p>
        <div className="govuk-form-group">
          <div className="govuk-body">
            <Input
              errorMessage={errorMsg}
              label={{
                children: copyProvider.getCopy(
                  'landlordReg.CompanyVATNumber.s5',
                  'UK VAT registration number'
                ),
              }}
              hint={{
                children: copyProvider.getCopy(
                  'landlordReg.CompanyVATNumber.s6',
                  'This is the unique number that HMRC provides to UK businesses when they register for tax payment'
                ),
              }}
              id="companyRegistrationNumber"
              className="govuk-input govuk-!-width-two-thirds"
              name="companyRegistration"
              type="text"
              value={businessVatRegistrationRedux}
              onChange={(event) => handleBusinessVatRegistration(event)}
            />
          </div>
        </div>
      </div>
      <div className="govuk-body govuk-!-font-size-19 govuk-!-padding-bottom-6">
        <Link className="govuk-link " to="/pmcReg/cannot-proceed">
          {copyProvider.getCopy(
            'landlordReg.CompanyVATNumber.s7',
            'I do not have a VAT registration number'
          )}
        </Link>
      </div>

      <Button className="govuk-button" onClick={handleBtnClick}>
        {copyProvider.getCopy('landlordReg.CompanyVATNumber.s8', 'Continue')}
      </Button>
    </>
  );

  return pageModel;
};

export default BusinessVatRegistration;
